import { createFileRoute } from '@tanstack/react-router';
import { WithdrawalDetailModule } from '@/modules/promoters/withdraw-request/withdrawal-detail';

export const Route = createFileRoute(
  '/dashboard/promoters/withdraw-request/$withdrawalId'
)({
  component: WithdrawalDetailModule,
});
